var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateDeviceInstallments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.438 3c-1.152 0-2.09.978-2.09 2.17v22.573l-.255-.255-.696.697-.871.871-.697-.697-.95-.924-.697.697-.911.897-.697-.697-.924-.91-.697.696-.884.871-.697-.697-.83-.804-.697.697-.737.724-.697-.697-.83-.804-.697.697-.884.87V5.922C2.027 4.313 3.286 3 4.813 3h13.625z",
    fill: "url(#e4wc5ei6ua)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.608 3a2.17 2.17 0 0 0-2.17 2.17v1.3h4.34v-1.3A2.17 2.17 0 0 0 20.609 3z",
    fill: "url(#im2fyg11yb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M6.97 3a2.927 2.927 0 0 0-2.92 2.92v21.85l-.375-.348-.724.696-.924.871V5.921C2.027 4.313 3.34 3 4.934 3H6.97z",
    fill: "url(#n7gl2k9yrc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.207 7.756h1.956m-1.956 3.376h7.957m-7.957 3.363h7.957M6.207 17.87h7.957M11.78 24h2.384m4.274-17.53h4.354V5.184A2.184 2.184 0 0 0 20.608 3m0 0c-1.205 0-2.17.978-2.17 2.184v6.457M20.608 3H4.948a2.927 2.927 0 0 0-2.921 2.92v23.056l1.648-1.554 1.594 1.487 1.5-1.407 1.581 1.487 1.648-1.554 1.688 1.594 1.675-1.58 1.714 1.607 1.648-1.554 1.715 1.62v-9.497M6.207 21h7.957",
    stroke: "url(#bmmk7j081d)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.53 22.102a6.47 6.47 0 1 0 0-12.942 6.47 6.47 0 0 0 0 12.942z",
    stroke: "url(#0iid8wxlne)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.863 12.766v3.67h-2.8",
    stroke: "url(#kp5prrrkaf)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e4wc5ei6ua",
    x1: 14.197,
    y1: 43.014,
    x2: -4.017,
    y2: 38.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "im2fyg11yb",
    x1: 21.659,
    y1: 8.329,
    x2: 17.544,
    y2: 6.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n7gl2k9yrc",
    x1: 5.695,
    y1: 42.912,
    x2: -0.085,
    y2: 42.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bmmk7j081d",
    x1: 17.435,
    y1: 43.117,
    x2: -4.821,
    y2: 36.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0iid8wxlne",
    x1: 26.661,
    y1: 29.034,
    x2: 13.47,
    y2: 23.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp5prrrkaf",
    x1: 23.141,
    y1: 18.403,
    x2: 20.119,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateDeviceInstallments);
export default __webpack_public_path__ + "static/media/corporateDeviceInstallments.759e73d194dc1f15df3105ac91302f23.svg";
export { ForwardRef as ReactComponent };